import io from 'socket.io-client';

export const startSocket = async (userId, merchantId, token) => {
  return await io(process.env.REACT_APP_SOCKET_URL, {
    // Prioritize WebSocket, fall back to polling if WebSocket blocked
    transports: ['websocket', 'polling'],
    
    // Use Socket.IO v3+ auth object (persists across all transports)
    auth: {
      token: token,
    },
    
    // Also send in extraHeaders at root level (backup/compatibility)
    extraHeaders: {
      Authorization: token,
      'x-clientbook-user-id': userId,
      'x-clientbook-merchant-id': merchantId,
    },
    
    // Configure headers for BOTH transports
    transportOptions: {
      polling: {
        extraHeaders: {
          Authorization: token,
          'x-clientbook-user-id': userId,
          'x-clientbook-merchant-id': merchantId,
        },
      },
      websocket: {
        extraHeaders: {
          Authorization: token,
          'x-clientbook-user-id': userId,
          'x-clientbook-merchant-id': merchantId,
        },
      },
    },
  });
};
